// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonCardsLayout_container__3A5Ev","row":"SkeletonCardsLayout_row__3SkIk","card":"SkeletonCardsLayout_card__3nIpG"};